import React, { useState } from "react";
import {
	PaymentElement,
	useStripe,
	useElements
} from "@stripe/react-stripe-js";
import { getBaseMessagerieUrl } from "../../../../../../utils/baseUrl";

// eslint-disable-next-line react/prop-types
export default function CheckoutForm() {

	const stripe = useStripe();
	const elements = useElements();

	// const [isLoading, setIsLoading] = useState(false);
	const isLoading = (false);
	const [errorMessage, setErrorMessage] = useState(null);


	const handleSubmit = async (event) => {
		// We don't want to let default form submission happen here,
		// which would refresh the page.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		const { error } = await stripe.confirmSetup({
			//`Elements` instance that was used to create the Payment Element
			elements,
			confirmParams: {
				return_url: `${getBaseMessagerieUrl()}/`,
			}
		});

		if (error) {
			// This point will only be reached if there is an immediate error when
			// confirming the payment. Show error to your customer (e.g., payment
			// details incomplete)
			setErrorMessage( "Une erreur est survenue, veuillez essayer de nouveau " + error.message);
		} else {
			// Your customer will be redirected to your `return_url`. For some payment
			// methods like iDEAL, your customer will be redirected to an intermediate
			// site first to authorize the payment, then redirected to the `return_url`.
			setErrorMessage("Une erreur est survenue, veuillez essayer de nouveau");
		}
	};

	const element = document.getElementById("payment-element");

	if (element) {
		element.style.padding = "1px";
		element.style.padding = "2px";
		element.style.padding = "3px";
	}

	return (
		<>
			{!isLoading &&
				<form id="payment-form" onSubmit={handleSubmit}>
					<PaymentElement id="payment-element" />
				</form>
			}
			{errorMessage && <h1>{errorMessage}</h1>}
			{isLoading && <h1>Chargement</h1>}
		</>
	);
}